import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { cn } from '../../../lib/utils';

export interface TaskySheetProps {
  open: boolean;
  onClose: () => void;
  /** 読み上げ用のラベル（見出しは children 側に置く） */
  label: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * 画面全体を覆うシート（スマホの作業パネルなど）。下からせり上がり、Esc で閉じる。開いている間は背面をスクロールさせない。
 * 見出しと閉じるボタンは中身側で持つ（パネルごとにヘッダーの形が違うため）。
 */
export const TaskySheet: React.FC<TaskySheetProps> = ({ open, onClose, label, children, className }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    const previous = document.body.style.overflow;
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = previous;
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-label={label}
      // 全画面の作業面なので、右上に常駐するクレジット等の浮きボタン（PrivateRoute の z-[1000]）より上に出す
      className={cn('fixed inset-0 z-[1001] flex flex-col bg-white animate-slide-in motion-reduce:animate-none', className)}
    >
      {children}
    </div>,
    document.body,
  );
};
